type ClassValue = string | false | null | undefined;

/**
 * Small className joiner for generated semantic utilities that tailwind-merge
 * does not understand yet. Use when preserving both a typography role class
 * (`text-heading-md`) and a semantic color class (`text-text-primary`) matters.
 */
export function cx(...classNames: ClassValue[]): string {
  return classNames.filter(Boolean).join(" ");
}
